import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field } from 'formik';

import Heading from '../../common/Heading';
import { TextInput, CheckboxInput } from '../../common/FormFields';

import formStyles from '../../styles/forms.module.scss';
import s from './StepIndividualOffer.module.scss';
import YourData from './YourData/YourData';
import FormikControlledComboBox from '../../common/FormFields/ComboBox/FormikControlledComboBox';

type StepIndividualOfferProps = {
  values: any;
  submitted: boolean;
};

function StepIndividualOffer(props: StepIndividualOfferProps) {
  const { values, submitted } = props;
  const intl = useIntl();
  const salutations = [
    {
      id: 'Frau',
      name: intl.formatMessage({
        id: 'offerWizard.StepIndividualOffer.salutation.ms',
      }),
    },
    {
      id: 'Herr',
      name: intl.formatMessage({
        id: 'offerWizard.StepIndividualOffer.salutation.mr',
      }),
    },
    {
      id: 'notSpecified',
      name: intl.formatMessage({
        id: 'offerWizard.StepIndividualOffer.salutation.notSpecified',
      }),
    },
  ] as const;

  return (
    <section className={s.stepSomeInformation}>
      <Heading level={2}>
        <FormattedMessage id="offerWizard.StepIndividualOffer.title" />
      </Heading>
      <p>
        <FormattedMessage id="offerWizard.StepIndividualOffer.introText" />
      </p>
      <div className={`${formStyles.formFields} ${s.form}`}>
        <div className={formStyles.inputPairSingle}>
          <Field
            name="individualOffer.salutation"
            component={FormikControlledComboBox}
            options={salutations}
            labelMsg="offerWizard.StepIndividualOffer.salutation.label"
            isRequired
          />
        </div>
        <div className={formStyles.inputPair}>
          <Field
            name="individualOffer.firstName"
            labelMsg="offerWizard.StepIndividualOffer.firstName.label"
            component={TextInput}
            fullWidth
            labelClass={formStyles.fullWidthField}
            required
            disabled={submitted}
            autoComplete="given-name"
          />
          <Field
            name="individualOffer.lastName"
            labelMsg="offerWizard.StepIndividualOffer.lastName.label"
            component={TextInput}
            fullWidth
            labelClass={formStyles.fullWidthField}
            required
            disabled={submitted}
            autoComplete="family-name"
          />
        </div>
        <Field
          name="individualOffer.position"
          labelMsg="offerWizard.StepIndividualOffer.position.label"
          component={TextInput}
          fullWidth
          labelClass={formStyles.fullWidthField}
          disabled={submitted}
          autoComplete="organization-title"
        />
        <div className={formStyles.inputPair}>
          <Field
            name="individualOffer.phone"
            labelMsg="offerWizard.StepIndividualOffer.phone.label"
            component={TextInput}
            disabled={submitted}
            fieldType="tel"
            autoComplete="tel"
          />
          <Field
            name="individualOffer.email"
            labelMsg="offerWizard.StepIndividualOffer.email.label"
            component={TextInput}
            required
            disabled={submitted}
            fieldType="email"
            autoComplete="email"
          />
        </div>
        <div className={formStyles.fullWidthField}>
          <Field
            name="individualOffer.privacyPolicy"
            labelContent={
              <>
                <div className={s.h5}>
                  <FormattedMessage id="offerWizard.StepIndividualOffer.accepted1" />
                </div>
                <FormattedMessage id="offerWizard.StepIndividualOffer.accepted2" />
              </>
            }
            component={CheckboxInput}
            disabled={submitted}
          />
        </div>
      </div>
      <Heading level={3} className={s.yourDataHeading}>
        <FormattedMessage id="offerWizard.StepIndividualOffer.yourData" />
      </Heading>
      <YourData values={values} />
    </section>
  );
}

export default StepIndividualOffer;
